import { lazy } from 'react'

const routes = [
  {
    path: '/',
    component: lazy(() => import('../pages/home'))
  },
  {
    path: '/device',
    component: lazy(() => import('../pages/device'))
  },
  {
    path: '/device/router',
    component: lazy(() => import('../pages/device/router'))
  },
  {
    path: '/device/router/flow-pool',
    component: lazy(() => import('../pages/device/router/flow-pool'))
  },
  {
    path: '/device/router/flow-pool/history',
    component: lazy(() => import('../pages/device/router/flow-pool/History'))
  },
  {
    path: '/device/records',
    component: lazy(() => import('../pages/device/Records'))
  },
  {
    path: '/device/router/detail/:id',
    component: lazy(() => import('../pages/device/router/detail'))
  },
  {
    path: '/device/router/setting',
    component: lazy(() => import('../pages/device/router/setting'))
  },
  {
    path: '/device/router/terminal',
    component: lazy(() => import('../pages/device/router/terminal'))
  },
  {
    path: '/device/router/terminal/detail/:macAddr',
    component: lazy(() => import('../pages/device/router/terminal/detail'))
  },
  {
    path: '/device/camera',
    component: lazy(() => import('../pages/device/camera'))
  },
  {
    path: '/device/config-template',
    component: lazy(() => import('../pages/device/ConfigTemplate'))
  },
  {
    path: '/customer',
    component: lazy(() => import('../pages/customer'))
  },
  {
    path: '/customer/detail/:id',
    component: lazy(() => import('../pages/customer/Detail'))
  },
  {
    path: '/customer/personalize',
    component: lazy(() => import('../pages/customer/personalize/'))
  },
  {
    path: '/shop',
    component: lazy(() => import('../pages/shop'))
  },
  {
    path: '/shop/detail/:id',
    component: lazy(() => import('../pages/shop/detail'))
  },
  {
    path: '/shop/confirm/:id',
    component: lazy(() => import('../pages/shop/order/Confirm'))
  },
  {
    path: '/shop/order/detail/:id',
    component: lazy(() => import('../pages/shop/order/Detail'))
  },
  {
    path: '/shop/order',
    component: lazy(() => import('../pages/shop/order/index'))
  },
  {
    path: '/shop/result/:id',
    component: lazy(() => import('../pages/shop/Result'))
  },
  {
    path: '/finance',
    component: lazy(() => import('../pages/finance'))
  },
  {
    path: '/finance/renew',
    component: lazy(() => import('../pages/finance/renew'))
  },
  {
    path: '/finance/renew/list',
    component: lazy(() => import('../pages/finance/RenewList'))
  },
  {
    path: '/finance/recharge',
    component: lazy(() => import('../pages/finance/recharge'))
  },
  {
    path: '/camera',
    component: lazy(() => import('../pages/camera'))
  },
  {
    path: '/camera/playback/:id',
    component: lazy(() => import('../pages/camera/playback'))
  }
]

export default routes
